import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=84b4cc70&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b4cc70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84b4cc70')) {
      api.createRecord('84b4cc70', component.options)
    } else {
      api.reload('84b4cc70', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=84b4cc70&scoped=true&", function () {
      api.rerender('84b4cc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26KGYIzSoANXE/JS/comp/Voucher-Unit.vue"
export default component.exports